module.exports = __webpack_public_path__ + "static/media/abbiamo15.2d6727b0.png";